import React from 'react';
import './Userterms.css';
import Sidebar from '../Repoter/Sidebar/Sidebar';
import NavBar from '../NavBar/NavBar';
import RunningHeader from '../RunningHeader/RunningHeader';
import Footer from '../Footer/Footer';

const Userterms = () => {
  return (
    <div>
      <NavBar/>
      <RunningHeader/>
    <div className="terms-container">
      <h1>Terms and Conditions</h1>

      <section>
        <h2>General Terms</h2>
        <ol>
          <li><strong>Acceptance of Terms:</strong> By using our news channel, you agree to these terms and conditions.</li>
          <li><strong>User Conduct:</strong> You agree to use our news channel for lawful purposes only.</li>
          <li><strong>Intellectual Property:</strong> All content on our news channel is owned by us or our licensors.</li>
        </ol>
      </section>

      <section>
        <h2>User Account Terms</h2>
        <ol>
          <li><strong>Registration:</strong> You must register with us to use certain features of our news channel.</li>
          <li><strong>Username and Password:</strong> You are responsible for maintaining the confidentiality of your username and password.</li>
          <li><strong>Account Security:</strong> You agree to notify us immediately of any unauthorized use of your account.</li>
        </ol>
      </section>

      <section>
        <h2>Content Terms</h2>
        <ol>
          <li><strong>User-Generated Content:</strong> You grant us a license to use, modify, and distribute any content you submit to us.</li>
          <li><strong>Content Guidelines:</strong> You must comply with our content guidelines, which prohibit hate speech, harassment, and other forms of objectionable content.</li>
          <li><strong>Copyright:</strong> You agree not to infringe on the copyrights of others.</li>
        </ol>
      </section>

      <section>
        <h2>Prohibited Activities</h2>
        <ol>
          <li><strong>Hate Speech:</strong> You agree not to post or transmit hate speech or discriminatory content.</li>
          <li><strong>Harassment:</strong> You agree not to harass or intimidate other users.</li>
          <li><strong>Spam:</strong> You agree not to post or transmit spam or unsolicited commercial content.</li>
        </ol>
      </section>

      <section>
        <h2>Disclaimers and Limitations of Liability</h2>
        <ol>
          <li><strong>No Warranty:</strong> Our news channel is provided "as is" without warranties of any kind.</li>
          <li><strong>No Liability:</strong> We are not liable for any damages arising from your use of our news channel.</li>
          <li><strong>Indemnification:</strong> You agree to indemnify us against any claims, damages, or expenses arising from your use of our news channel.</li>
        </ol>
      </section>
    </div>
     <Footer/>
     </div>
  );
};

export default Userterms;
